// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[size=icon-micro][data-v-84b34b50]{height:16px;width:16px}[size=icon-sm][data-v-84b34b50]{height:20px;width:20px}[size=icon-md][data-v-84b34b50]{height:24px;width:24px}[size=icon-lg][data-v-84b34b50]{height:30px;width:30px}svg[data-v-84b34b50]{fill:currentColor;stroke:none}", ""]);
// Exports
module.exports = exports;
